import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import {ItemMasterBasic10_EarningPtsGeneratorElement} from "../models/ItemMasterBasic10_EarningPtsGeneratorModel";


//  import {ItemMasterHeaderSubDescElement} from "../models/ItemMasterHeaderSubDescModel";
import { environment } from '../../environments/environment';
//   private apiUrl = environment.apiUrl;


@Injectable()
export class ItemMasterBasic10_EarningPtsGeneratorService {

    //// import { environment } from '../../../environments/environment';
    private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }



  /////////////////////////  ------------  GET ALL ------------  ////////////////////////////////////////////////


  getAllItemBasicEarningPtsGenerator() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
return this.http.get(""+this.apiUrl+"/ItemMasterBasic10_EarningPts/GetAllEarningPtsGenerator",httpOptions);

 //return this.http.get("http://localhost:57597/api/ItemBasic8_Coupon/GetAllCouponGenerator",httpOptions);

  }

  
  getAllItemBasicRedeemPtsGenerator() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  
return this.http.get(""+this.apiUrl+"/ItemMasterBasic10_EarningPts/GetAllRedeemPtsGenerator",httpOptions);

 //return this.http.get("http://localhost:57597/api/ItemBasic8_Coupon/GetAllCouponGenerator",httpOptions);

  }
  ///////////////////////  ----------- GET ALL BY ID ----------- ///////////////////////////////////////////////



  addItemBasicEarningPtsGenerator(app:ItemMasterBasic10_EarningPtsGeneratorElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

  return this.http.post(""+this.apiUrl+"/ItemMasterBasic10_EarningPts/AddItemBasic10EarningPtsGenerator",
  JSON.stringify(app),
   httpOptions
  )


  // return this.http.post('http://localhost:57597/api/ItemBasic8_Coupon/AddItemBasic8CouponGenerator',
  // JSON.stringify(app),
  //  httpOptions
  // )


  }

  
  
 //  int AdmissionMasterId, string Category, int EarningPtsId  
  GetAllEarningRedemmPoints(  AdmissionMasterIds:number,    EarningPtsIds:number , Category:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
 // return this.http.get(""+this.apiUrl+"/ItemMasterBasic10_EarningPts/GetAllEarningRedemmPoints?AdmissionMasterId="+AdmissionMasterIds+"Category="+Category+"EarningPtsId="+EarningPtsIds,httpOptions);

  /// return this.http.get("http://localhost:49587/api/ItemMasterBasic10_EarningPts/GetAllEarningRedemmPoints?AdmissionMasterId="+AdmissionMasterIds+"&EarningPtsId="+EarningPtsIds+"&Category="+Category,httpOptions);
  return this.http.get(""+this.apiUrl+"/ItemMasterBasic10_EarningPts/GetAllEarningRedemmPoints?AdmissionMasterId="+AdmissionMasterIds+"&EarningPtsId="+EarningPtsIds+"&Category="+Category,httpOptions);

  }
  
  saveUploadUpdateData(data) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };

    return this.http.post<any>(""+this.apiUrl+"/ItemMasterBasic10_EarningPts/UploadUpdateData",data, {
      reportProgress: true,
      observe: 'events'
    });

    // return this.http.post<any>("http://localhost:49587/api/ItemMasterBasic10_EarningPts/UploadUpdateData",data, {
    //   reportProgress: true,
    //   observe: 'events'
    // });

  }

  getItemMasterBasic10_Pts(  mid:number,  cat:number , cb:number ) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    
 // return this.http.get(""+this.apiUrl+"/ItemMasterBasic10_EarningPts/GetAllEarningRedemmPoints?AdmissionMasterId="+AdmissionMasterIds+"Category="+Category+"EarningPtsId="+EarningPtsIds,httpOptions);

  /// return this.http.get("http://localhost:49587/api/ItemMasterBasic10_EarningPts/GetAllEarningRedemmPoints?AdmissionMasterId="+AdmissionMasterIds+"&EarningPtsId="+EarningPtsIds+"&Category="+Category,httpOptions);
  return this.http.get(""+this.apiUrl+"/ItemMasterBasic10_EarningPts/GetItemMasterBasic10_Pts?AdmissionMasterId="+mid+"&Category="+cat+"&CreatedBy="+cb,httpOptions);

  }


  getAllEarningRedeemingCouponCalculationData(mid:number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };    
 
  return this.http.get(""+this.apiUrl+"/ItemMasterBasic10_EarningPts/GetAllEarningRedeemingCouponCalculation?AdmissionMasterId="+mid,httpOptions);

  }


}
